"use strict";

exports.__esModule = true;
exports.withTimer = withTimer;
var _react = _interopRequireDefault(require("react"));
var _Timer = require("./Timer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * HOC for timers.
 * Returns a function which turns a component into one which automatically
 * receives a `now` prop.
 */
function withTimer(interval) {
  return function (Component) {
    return function (props) {
      return /*#__PURE__*/_react["default"].createElement(_Timer.Timer, {
        interval: interval
      }, function (_ref) {
        var now = _ref.now;
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
          now: now
        }));
      });
    };
  };
}